import BaseModelAPI from '../BaseModelAPI';

export default class PartGoodReceiptDetail extends BaseModelAPI {
	static entity = 'partgoodreceiptdetail';
	static entityName = 'partgoodreceiptdetail';

	constructor(){

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.partGoodReceiptId = '';
		this.partGoodReceipt = {};
		this.purchaseOrderDetailId = '';
		this.purchaseOrderDetail = {};
		this.partId = '';
		this.part = {};
		this.qtyOutstandingBefore = 0;
		this.qtyReceived = 0;
		this.qtyActual = 0;
		this.qtyOutstandingAfter = 0;
		this.remark = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.isAlreadyQc = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}